import { render } from "./FastfoodIcon.vue?vue&type=template&id=5c2cc0fd"
const script = {}

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__